import { render, staticRenderFns } from "./routeConfigList.vue?vue&type=template&id=25be5c5c&scoped=true"
import script from "./routeConfigList.vue?vue&type=script&lang=js"
export * from "./routeConfigList.vue?vue&type=script&lang=js"
import style0 from "./routeConfigList.vue?vue&type=style&index=0&id=25be5c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be5c5c",
  null
  
)

export default component.exports